import { useAppSelector } from '@common-reducers/hooks/store.hook'
import { Stack } from '@mui/material'
import { LinkPreviewButton } from './link-preview-button'
import { ToggleEditorTypeToPollOrMessageButton } from "./toggle-editor-type-to-poll-or-message-button"
import { selectScheduleRecipients } from '@common-reducers/AddScheduledMessageButtonReducer'
import { hasStatusRecipient } from '@common/scheduling/status-recipient'


export default function MessageEditorFooter() {
    const isPoll = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.isPoll);
    const editorContext = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.editorContext);
    const assetType = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.asset?.type);
    // FE#384 — while a link preview exists the compact strip owns edit/removal, so
    // the "Update Link Preview" button is hidden (per the handoff).
    const sendLinkPreview = useAppSelector((state: any) => state.ScheduledMessageEditorReducer.sendLinkPreview);
    // Compute editorType from Redux state
    const editorType = isPoll ? 'poll' : 'message';
    const isAttachmentSound = assetType?.includes('audio')
    // A WhatsApp Status can't be a poll: no "Set a Poll" in the schedule dialog's Status mode.
    const scheduleRecipients = useAppSelector(selectScheduleRecipients)
    const isStatus = editorContext === 'scheduleMessage' && hasStatusRecipient(scheduleRecipients)

    return (
        <Stack direction='row' className="bt-msg-editor-footer" sx={{
            justifyContent: 'flex-start', gap: '5px', alignItems: 'center', borderBottom: '1px solid var(--tasks-cell-border)', borderRight: '1px solid var(--tasks-cell-border)', borderLeft: '1px solid var(--tasks-cell-border)', marginTop: '0px !important',
            borderRadius: '0px 0px 10px 10px', p: '5px',
            backgroundColor: 'var(--color-surface)',
            flexWrap: 'wrap',
            // Pin the editor controls (poll / link preview) to the bottom of the
            // scrollable message panel so they stay visible on short viewports
            // (only the text input scrolls) — EXCEPT the schedule-message dialog
            // (prod FE#385): there a sticky row slid UP over the text box on short
            // 13-14" screens. FE#384 — "Cancel when a message is received" moved to
            // the Options tab; it cost a second row here.
            ...(editorContext === 'scheduleMessage' ? {} : {
                position: 'sticky',
                bottom: 0,
                zIndex: 2,
            }),
        }}>

            {/* Toggle Editor Type Button - Always visible at bottom */}
            <Stack direction="row" spacing={1} sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
                {!isStatus && <ToggleEditorTypeToPollOrMessageButton />}

                {editorType !== 'poll' && !isAttachmentSound && !sendLinkPreview && <LinkPreviewButton />}
            </Stack>
        </Stack>
    )
}
